export default __webpack_public_path__ + "static/media/userpicFemale.8163d0c4.svg";